module.exports = __webpack_public_path__ + "static/media/acto_de_grado_9.1dd3bc4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/acto_de_grado_9.jpg
// module id = 916
// module chunks = 0